import type { ReactElement, ReactNode } from 'react';
import { t } from '@fetmode/i18n';

import './SettingsLayout.css';

export function SettingsStack({
  titleKey,
  hintKey,
  children,
}: {
  titleKey: string;
  hintKey?: string;
  children: ReactNode;
}): ReactElement {
  return (
    <section>
      <h1 style={{ fontFamily: 'var(--fm-font-heading)', marginTop: 0 }}>{t(titleKey)}</h1>
      {hintKey ? (
        <p style={{ color: 'var(--fm-color-text-muted)', marginTop: 0 }}>{t(hintKey)}</p>
      ) : null}
      <div className="studio-settings__stack">{children}</div>
    </section>
  );
}
